import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-new-pre-use-inspection-header',
  templateUrl: './add-new-pre-use-inspection-header.component.html',
  styleUrls: ['./add-new-pre-use-inspection-header.component.scss'],
  standalone: false
})
export class AddNewPreUseInspectionHeaderComponent {

  isMobileApp = input<boolean>();

  constructor() { }

}
